import { Text, Button, Flex, Grid, Box, useMediaQuery } from "@chakra-ui/react";
import NextImage from "next/legacy/image";
import { FaShoppingCart } from "react-icons/fa";
import useTotalCheckout from "@/hooks/useTotalCheckout";

const CURRENCY = "$";

export const Total = ({ profilePlan, revisionPlan, onCheckout, isLoading }) => {
  const [isMobile] = useMediaQuery("(max-width: 768px)");

  const {
    profileSavings,
    revisionSavings,
    profilePrice,
    revisionsPrice,
    discountCredits,
    affiliateCredits,
    finalPrice,
    dollarDiscount,
  } = useTotalCheckout({ profilePlan, revisionPlan });

  return (
    <Flex flexDir="column">
      {isMobile && (
        <Text fontSize="2xl" fontWeight={600} mt={4}>
          Total:
        </Text>
      )}
      <Flex
        border="2px dashed #000"
        borderRadius="10px"
        px={{ base: 1, md: 4 }}
        py={2}
        my={4}
        gap={2}
      >
        {!isMobile && (
          <Text fontSize="2xl" fontWeight={600}>
            Total:
          </Text>
        )}

        <Flex direction="column" gap={2} flex="1">
          {profilePlan && (
            <Grid
              templateColumns={{ base: "1fr 1fr 70px", md: "1fr 1fr 100px" }}
              gap={{ base: 1, md: 2 }}
              alignItems="center"
            >
              {/* Plan */}
              <Flex align="center" gap={2}>
                <NextImage src="/images/icons/credits-icon.svg" width="40px" height="40px" />

                <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }}>
                  {profilePlan.credits}
                </Text>
              </Flex>

              {/* Savings */}
              {!!profileSavings ? (
                <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }} color="#C84E9D">
                  {profileSavings}% saving
                </Text>
              ) : (
                <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }} color="#A6A6A6">
                  no saving
                </Text>
              )}

              {/* Price */}
              {!!profileSavings ? (
                <Flex>
                  <Text
                    fontWeight={600}
                    fontSize={{ base: "sm", md: "md" }}
                    color="#C84E9D"
                    textDecoration="line-through"
                    mt={1}
                  >
                    {CURRENCY}
                    {profilePlan.initialPrice}
                  </Text>

                  <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }}>
                    {CURRENCY}
                    {profilePrice}
                  </Text>
                </Flex>
              ) : (
                <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }}>
                  {CURRENCY}
                  {profilePrice}
                </Text>
              )}
            </Grid>
          )}

          {revisionPlan && (
            <Grid
              templateColumns={{ base: "1fr 1fr 70px", md: "1fr 1fr 100px" }}
              gap={{ base: 1, md: 2 }}
              alignItems="center"
            >
              {/* Plan */}
              <Flex align="center" gap={2}>
                <Box width="40px">
                  {!revisionPlan.credits ? (
                    <NextImage
                      src="/images/icons/essay-credits.svg"
                      width="40px !important"
                      height="40px"
                    />
                  ) : (
                    <NextImage src="/images/icons/credits-icon.svg" width="40px" height="40px" />
                  )}
                </Box>

                <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }} lineHeight={1.1}>
                  {revisionPlan.credits ? revisionPlan.credits : revisionPlan.title}
                </Text>
              </Flex>

              {/*  Savings */}
              {!!revisionSavings ? (
                <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }} color="#C84E9D">
                  {revisionSavings}% saving
                </Text>
              ) : (
                <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }} color="#A6A6A6">
                  no saving
                </Text>
              )}

              {/* Price */}
              {revisionPlan &&
                (!!revisionSavings ? (
                  <Flex>
                    <Text
                      fontWeight={600}
                      fontSize={{ base: "sm", md: "md" }}
                      color="#C84E9D"
                      textDecoration="line-through"
                      mt={1}
                    >
                      {CURRENCY}
                      {revisionPlan.initialPrice}
                    </Text>

                    <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }}>
                      {CURRENCY}
                      {revisionsPrice}
                    </Text>
                  </Flex>
                ) : (
                  <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }}>
                    {CURRENCY}
                    {revisionsPrice}
                  </Text>
                ))}
            </Grid>
          )}

          {!!affiliateCredits && (
            <Grid
              templateColumns={{ base: "1fr 1fr 70px", md: "1fr 1fr 100px" }}
              gap={{ base: 1, md: 2 }}
            >
              <Flex align="center" gap={2}>
                <NextImage src="/images/icons/credits-icon.svg" width="40px" height="40px" />

                <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }}>
                  {affiliateCredits}
                </Text>
              </Flex>

              <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }} color="#C84E9D">
                Affiliate multiplier
              </Text>
            </Grid>
          )}

          {!!discountCredits && (
            <Grid
              templateColumns={{ base: "1fr 1fr 70px", md: "1fr 1fr 100px" }}
              gap={{ base: 1, md: 2 }}
            >
              <Flex align="center" gap={2}>
                <NextImage src="/images/icons/credits-icon.svg" width="40px" height="40px" />

                <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }}>
                  {discountCredits}
                </Text>
              </Flex>

              <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }} color="#C84E9D">
                Discount Multiplier
              </Text>
            </Grid>
          )}

          {!!dollarDiscount && (
            <Grid
              templateColumns={{ base: "1fr 1fr 70px", md: "1fr 1fr 100px" }}
              gap={{ base: 1, md: 2 }}
            >
              <Flex align="center" gap={2}>
                {/*<NextImage src="/images/icons/credits-icon.svg" width="40px" height="40px" />*/}

                {/*<Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }}>*/}
                {/*  {dollarDiscount}*/}
                {/*</Text>*/}
              </Flex>

              <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }} color="#C84E9D">
                Discount Amount
              </Text>

              <Text fontWeight={600} fontSize={{ base: "sm", md: "lg" }} color="#C84E9D">
                -{CURRENCY}
                {dollarDiscount}
              </Text>
            </Grid>
          )}
        </Flex>
      </Flex>

      {!!finalPrice && (
        <Button
          leftIcon={<FaShoppingCart />}
          isLoading={isLoading}
          disabled={isLoading}
          bg="#000"
          color="#fff"
          colorScheme="blackAlpha"
          sx={{ "&:hover": { bg: "#000" }, marginLeft: "auto" }}
          fontSize={{ base: "md", md: "xl" }}
          onClick={async () => {
            await onCheckout();
          }}
        >
          Check Out {CURRENCY}
          {finalPrice}
        </Button>
      )}
    </Flex>
  );
};
